import { render, staticRenderFns } from "./RobRedBagList.vue?vue&type=template&id=3a88d77c&scoped=true"
import script from "./RobRedBagList.vue?vue&type=script&lang=js"
export * from "./RobRedBagList.vue?vue&type=script&lang=js"
import style0 from "./RobRedBagList.vue?vue&type=style&index=0&id=3a88d77c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a88d77c",
  null
  
)

export default component.exports